import React from 'react'

import {
  Box,
  Text,
  Icon,
  Display,
  FlexDirection,
  AlignItems,
  Space,
} from '@gousto-internal/citrus-react'

import { SecurePaymentMethodsSvg } from './SecurePaymentMethodsSvg'

export const SecurePaymentBanner = () => (
  <Box
    display={Display.Flex}
    flexDirection={FlexDirection.Column}
    alignItems={AlignItems.Center}
    paddingV={[4, 6]}
    paddingBottom={0}
    data-testid="securePaymentBanner"
  >
    <Box display={Display.Flex} paddingBottom={2} alignItems={AlignItems.Center}>
      <Icon name="secure" />
      <Space direction="horizontal" size={2} />
      <Text size={2}>Secure payments with</Text>
    </Box>
    <SecurePaymentMethodsSvg />
  </Box>
)
